import React from 'react';

interface Props {
  progress: number; // 0..1
  size: number;
  width: number;
  children?: React.ReactNode; // centered content
}

/** A circular progress ring, matching the reference app's progress arc. */
export default function ProgressArc({ progress, size, width, children }: Props) {
  const clamped = Math.max(0, Math.min(1, progress));
  const r = (size - width) / 2;
  const c = size / 2;
  const circumference = 2 * Math.PI * r;
  const dash = circumference * clamped;

  return (
    <div className="arc" style={{ width: size, height: size }}>
      <svg width={size} height={size} aria-hidden="true" focusable="false">
        <circle cx={c} cy={c} r={r} stroke="var(--track)" strokeWidth={width} fill="none" />
        <circle
          cx={c}
          cy={c}
          r={r}
          stroke="var(--primary)"
          strokeWidth={width}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference - dash}`}
          // start at 12 o'clock and sweep clockwise
          transform={`rotate(-90 ${c} ${c})`}
        />
      </svg>
      <div className="arc__content">{children}</div>
    </div>
  );
}
